<template>
<div style="position:relative">
	<div style="position: absolute;left: 10px;top: 10px;">
		<v-btn v-if="pageStatus=='show'"
			  color="primary"
			  v-on:click="editModel()"
		>
			  编辑模式
		</v-btn>
		
		<v-btn v-if="pageStatus=='edit'"
			  color="primary"
			  v-on:click="addNew()"
		>
			  添加
		</v-btn>
		
		<v-btn
			v-bind:disabled="getSaveBtnDisable"
			  color="primary"
			  v-on:click="saveTemplate()"
		>
			保存
		</v-btn>
		
		<v-btn
			v-bind:disabled="pageStatus=='show'"
			  color="primary"
			  v-on:click="cancelSave()"
		>
			取消
		</v-btn>
		<v-btn
			  color="primary"
			  v-on:click="back()"
		>
			返回
		</v-btn>
	</div>
	<div style="height: 60px;"></div>
	<v-divider></v-divider>
<v-simple-table style="overflow-y: auto;height: 700px;">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" v-for="it in heads">
            {{it.name}}
          </th>
		  <th>检查方法</th>
		  <th>检查标准</th>
		  <th>分值</th>
		  <th v-if="pageStatus=='edit'">操作</th>
        </tr>
      </thead>
      <tbody v-if="pageStatus=='edit'">
			<tr v-for="nr in newrows" style="max-height: 40px;">
				<td>
					<v-select
					style="max-width: 300px;"
					  :items="getLevelItemsByPcode(nr.category_code)"
					  dense
					  outlined
					  @change="selectLevel1(nr)"
					  v-model="nr.level1_code"
					></v-select>
				</td>
				<td>
					<v-select
					style="max-width: 300px;"
					  :items="getLevelItemsByPcode(nr.level1_code)"
					  dense
					  outlined
					  @change="selectOption(nr)"
					  v-model="nr.level2_code"
					></v-select>
				</td>
				<td>
					<v-select
					style="max-width: 300px;"
					  :items="getLevelItemsByPcode(nr.level2_code)"
					  dense
					  outlined
					  @change="selectOption(nr)"
					  v-model="nr.level3_code"
					></v-select>
				</td>
				<td>
					<v-select
					style="max-width: 300px;"
					  :items="getOptionItemsByPcode(nr.level3_code)"
					  dense
					  outlined
					  @change="selectOption(nr)"
					  v-model="nr.option_code"
					></v-select>
				</td>
				<td>
					<v-input
					    disabled
					  >
					  {{getStandardByCode(nr.option_code)}}
					  </v-input>
				</td>
				<td>
					<v-text-field
					  v-model="nr.point"
					  class="mt-0 pt-0"
					  type="number"
					  max="10"
					></v-text-field>
				</td>
				<td style="width: 80px;">
					<span style="color: #2196F3;cursor:pointer;" @click="del(nr)">删除</span>
				</td> 
			</tr>
      </tbody>
	  
	  <tbody  v-if="pageStatus=='show'">
	  			<tr v-for="tr in tabledata">
					<td v-for="td in tr" v-if="td.is_exist" :rowspan="td.rowspan">
						{{td.name}}
					</td>
	  			</tr>
	  </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
import CategoryApi from "@/api/pd/category/CategoryApi.js";
export default {
  data() {
    return {
		heads:[],
		levels:[],
		level1:[],
		options:[],
		completes:[],
		tabledata:[],
		mergeIndex:[0,0,0],
		newrows:[],
		rownum:0,
		assessMethod:{},
		assessStandard:{},
		all_level:[],
		all_option:[],
		pageStatus:'edit'
    }
  },
  props:['category'],
  computed:{
	  getSaveBtnDisable(){
		  if(this.pageStatus=='edit'){
			  return false;
		  }else{
			  return true;
		  }
	  }
  },
  methods:{
	  getLevelModel(data){
		  CategoryApi.getLevelModel(data).then(
			  resp=>{
				  let result = resp.data.result;
				this.heads=result
			  }
		  );
	  },
	  getLevelItemsByPcode(pcode){
		  return this.all_level.filter((a)=>{
			  return a.pcode===pcode;
		  }).map((a)=>{
			  a.text=a.name;
			  a.value=a.code;
			  return a;
		  })
	  },
	  getOptionItemsByPcode(pcode){
		  return this.all_option.filter((a)=>{
			return a.pcode===pcode;
		  }).map((a)=>{
			a.text=a.assessMethod;
			a.value=a.code;
			return a;
		  })  
	  },
	  getLevelNameByCode(code){
	  		  let str= this.all_level.filter((a)=>{
	  		    return a.code===code;
	  		  }).map((a)=>{
	  		    return a.name;
	  		  })  
	  		  return str[0]
	  },
	  getStandardByCode(code){
	  		  let str= this.all_option.filter((a)=>{
	  		    return a.code===code;
	  		  }).map((a)=>{
	  		    return a.assessStandard;
	  		  })  
	  		  return str[0]
	  },
	  getMethodByCode(code){
	  		  let str= this.all_option.filter((a)=>{
	  		    return a.code===code;
	  		  }).map((a)=>{
	  		    return a.assessMethod;
	  		  })  
	  		  return str[0]
	  },
	  selectLevel1(nr,value_level1){
		  console.warn(this.newrows)
	  },
	  selectOption(nr){
		 console.warn(nr)
	  },
	  addNew(){
		  this.pageStatus="edit";
		  let newrow={
			rownum:++this.rownum,
			level1_code:'',
			level2_code:'',
			level3_code:'',
			option_code:'',
			point:10,
			category_code:this.$props['category'].code
		}
		this.newrows.push(newrow)
		console.log(this.rownum,'行',this.newrows)
	  },
	  editModel(){
		  this.pageStatus="edit";
	  },
	  del(nr){
		  this.newrows=this.newrows.filter((a)=>{
			  return a!==nr
		  })
	  },
	  cancelSave(){
		  this.pageStatus="show";
		  this.getCompletesView();
	  },
	  back(){
	  	this.$emit("back", {formStatus:'list'})
	  },
	  saveTemplate(){
		  this.pageStatus='wait';
		  let category_code=this.$props['category'].code;
		  let options=this.newrows;
		  if(options.length<1){
			  alert("请添加项目")
			  this.pageStatus='edit';
			  return false;
		  }
		  for(let x of options){
			  if(x.level1_code=='' || x.level2_code=='' || x.level3_code==''){
				  alert('还有项目未选择完全');
				  this.pageStatus='edit';
				  return false;
			  }
		  }
		  let data={
			  "category_code":category_code,
			  "options":options
		  }
		  CategoryApi.saveTemplateThree(data).then(
			resp=>{
				return resp
			}).then(resp=>{
			  console.log("saveTemplateThree",resp)
			  if(resp.data.errCode==0){
			  	this.pageStatus='show';
				this.getCompletesView();
			  }else{
			  	this.pageStatus='edit';
			  }
			  return resp.errCode;
		  })
	  },
	  getCompletesView(){
		  let category_id=this.$props['category'].id;
		  CategoryApi.getOptionThreeTemplateByCategoryId(category_id).then(
		  			  resp=>{
		  					let result = resp.data.result;
		  					this.completes=result;
		  					this.newrows=result;
		  					if(result.length>0){
		  						this.rownum=result[result.length-1].rownum
		  					}
		  					console.log("this.rownum===",this.rownum)
							console.table('completes',this.completes)
		  					if(result!=null && result.length>0){
		  						this.pageStatus='show';
		  					}
							this.tabledata=[]
							this.completes.forEach(cr=>{
								let level1_code=cr.level1_code;
								let level2_code=cr.level2_code;
								let level3_code=cr.level3_code;
								let option_code=cr.option_code
								let point=cr.point
								let tr_data = [
									{code:level1_code,name:this.getLevelNameByCode(level1_code),is_exist:true,rowspan:1},
									{code:level2_code,name:this.getLevelNameByCode(level2_code),is_exist:true,rowspan:1},
									{code:level3_code,name:this.getLevelNameByCode(level3_code),is_exist:true,rowspan:1},
									{code:option_code,name:this.getMethodByCode(option_code),is_exist:true,rowspan:1},
									{code:option_code,name:this.getStandardByCode(option_code),is_exist:true,rowspan:1},
									{code:option_code,name:point,is_exist:true,rowspan:1},
								];  
								this.tabledata.push(tr_data)
							})
							console.table('tabledata',this.tabledata)
							for(let i=0;i<this.completes.length;i++){
								if(i<this.completes.length-1){
									let cr = this.completes[i];
									let nr = this.completes[i+1];
									this.compareRowAndMerge(i,this.mergeIndex,this.tabledata);
									console.warn(this.tabledata)
								}
							}
		  			  }
		  );
	  },
	  compareRowAndMerge(curIndex,mergeIndex,tabledata){
		  let cr = tabledata[curIndex];
		  let nr =tabledata[curIndex+1];
		  let level1_code=cr[0].code;
		  let level2_code=cr[1].code;
		  let level3_code=cr[2].code;
		  
		  let level1_code_n=nr[0].code;
		  let level2_code_n=nr[1].code;
		  let level3_code_n=nr[2].code;
		 //  let tr_data = [
			// {code:level1_code,name:this.getLevelNameByCode(level1_code),is_exist:true,rowspan:1},
			// {code:level2_code,name:this.getLevelNameByCode(level2_code),is_exist:true,rowspan:1},
			// {code:level3_code,name:this.getLevelNameByCode(level3_code),is_exist:true,rowspan:1},
			// {code:option_code,name:this.getMethodByCode(option_code),is_exist:true,rowspan:1},
			// {code:option_code,name:this.getStandardByCode(option_code),is_exist:true,rowspan:1},
			// {code:option_code,point:0,is_exist:true,rowspan:1},
		 //  ];
		  if(level1_code==level1_code_n){
			tabledata[mergeIndex[0]][0].rowspan+=1;
			tabledata[curIndex+1][0].is_exist=false;
		  }
		  if(level2_code==level2_code_n){
		  	tabledata[mergeIndex[1]][1].rowspan+=1;
			tabledata[curIndex+1][1].is_exist=false;
		  }
		  if(level3_code==level3_code_n){
		  	tabledata[mergeIndex[2]][2].rowspan+=1;
			tabledata[curIndex+1][2].is_exist=false;
		  }
		  if(level1_code!=level1_code_n){
			  mergeIndex[0]=curIndex+1;
		  }
		  if(level2_code!=level2_code_n){
			  mergeIndex[1]=curIndex+1;
		  }
		  if( level3_code!=level3_code_n){
			  mergeIndex[2]=curIndex+1;
		  }
			  
	  }
	 
  },
  mounted(){
	  let category=this.$props['category'];
	  let category_id=category.id;
	  let code=category.code;
	  this.getLevelModel(category_id);
	  CategoryApi.getAllLevelLibByCategoryId(category_id).then(
	  			  resp=>{
	  				  let result = resp.data.result;
	  				  this.all_level=result;
	  			  }
	  );
	  
	  CategoryApi.getAllOptionLibByCategoryId(category_id).then(
	  			  resp=>{
	  				  let result = resp.data.result;
	  				  this.all_option=result;
	  			  }
	  );
	  
	 this.getCompletesView();
  }
};
</script>